import React, {useCallback} from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {IconButton} from '@mui/material';
import {ORANGE_COLOR} from '../../styles';

type SortedMetric = 'timeOnIce' | 'shiftCount' | 'energyRatio';
type Period = 'period1' | 'period2' | 'period3' | 'overtime';

export interface MetricSortObject {
  sortedMetric: SortedMetric;
  direction: 'ASC' | 'DESC' | '';
  period?: Period;
}

interface Props {
  sortedMetric: SortedMetric;
  currentSort?: MetricSortObject;
  period?: Period;
  onSortChange: (newSort: MetricSortObject) => void;
}

const TeamShiftUtilizationSort: React.FC<Props> = ({
  sortedMetric,
  currentSort,
  period,
  onSortChange,
}) => {
  const changeSortDirection = useCallback((oldSort: MetricSortObject) => {
    switch (oldSort.direction) {
      case 'DESC':
        return 'ASC';
      case 'ASC':
        return '';
      default:
        return 'DESC';
    }
  }, []);

  const onSortClick = useCallback(() => {
    if (
      !currentSort ||
      currentSort.sortedMetric !== sortedMetric ||
      (currentSort?.period && currentSort.period !== period) ||
      (!currentSort?.period && period)
    ) {
      onSortChange({sortedMetric, direction: 'DESC', period});
    } else {
      onSortChange({
        sortedMetric,
        direction: changeSortDirection(currentSort),
        period,
      });
    }
  }, [changeSortDirection, currentSort, onSortChange, period, sortedMetric]);
  if (
    (currentSort?.period && currentSort.period !== period) ||
    (!currentSort?.period && period)
  ) {
    return (
      <IconButton sx={{padding: 0}} disableRipple onClick={onSortClick}>
        <ArrowDropUpIcon fontSize="large" />
      </IconButton>
    );
  }
  return (
    <IconButton sx={{padding: 0}} disableRipple onClick={onSortClick}>
      {(!currentSort ||
        currentSort.sortedMetric !== sortedMetric ||
        currentSort.direction === '') && <ArrowDropDownIcon fontSize="large" />}
      {currentSort &&
        currentSort.sortedMetric === sortedMetric &&
        currentSort.direction === 'ASC' && (
          <ArrowDropUpIcon sx={{color: ORANGE_COLOR}} fontSize="large" />
        )}
      {currentSort &&
        currentSort.sortedMetric === sortedMetric &&
        currentSort.direction === 'DESC' && (
          <ArrowDropDownIcon sx={{color: ORANGE_COLOR}} fontSize="large" />
        )}
    </IconButton>
  );
};

export default TeamShiftUtilizationSort;
